import { render, staticRenderFns } from "./impersonateButton.vue?vue&type=template&id=499073f3&scoped=true"
import script from "./impersonateButton.vue?vue&type=script&lang=js"
export * from "./impersonateButton.vue?vue&type=script&lang=js"
import style0 from "./impersonateButton.vue?vue&type=style&index=0&id=499073f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499073f3",
  null
  
)

export default component.exports